import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollectionHandle } from '@adornis/baseql/server/collections.js';
import { publishFilter } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { BinaryBlob } from '@adornis/collab/db/scalars.js';
import { catchError, from, of, switchMap } from 'rxjs';

@Entity()
export class CollabUpdate extends MongoEntity {
  static override _class = 'CollabUpdate';
  static override _collectionName = 'collab-update';

  @Field(type => String)
  rid: Maybe<string>;

  @Field(type => String)
  userID: Maybe<string>;

  @Field(type => String)
  username: Maybe<string>;

  @Field(type => Date)
  createdAt: Maybe<Date>;

  @Field(type => BinaryBlob)
  content: Maybe<BinaryBlob>;
}

export const subscribeCollabUpdates = registerSubscription({
  type: () => [CollabUpdate],
  operationName: 'subscribeCollabUpdates',
  resolve: (rid: string) => {
    return (gqlFields: BaseQLSelectionSet<CollabUpdate>) => {
      const selector = {
        rid,
      };
      const handle = getCollectionHandle<CollabUpdate>(CollabUpdate._collectionName);
      return from(publishFilter(CollabUpdate._class)).pipe(
        switchMap(publishFilter => {
          return handle.watchQuery(publishFilter ? { $and: [publishFilter, selector] } : selector, {
            limit: 5,
            sort: {
              createdAt: -1,
            },
          });
        }),
        catchError(e => {
          return of([] as CollabUpdate[]);
        }),
      );
    };
  },
  options: {},
  params: [
    {
      name: 'rid',
      type: () => String,
    },
  ],
});
